import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    // fontFamily: "var(--font-roboto)",
  },
  palette: {
    primary: {
      light: "#757ce8",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#fff",
    },
    secondary: {
      light: "#15DB95",
      main: "#15DB95",
      dark: "#15DB95",
      contrastText: "#000",
    },
  },
});

export default theme;
